import React, { FC, useState, useEffect } from "react"
import { useAppLazyQuery } from "@phonero/common-ux"
import cx from "classnames"
import css from "./Address.module.scss"
import { Input } from "@phonero/phonero-ui-lib"
import { PuxLabel, useTranslation } from "@phonero/pux-react"
import { ZipCodeDocument } from "@phonero/common-ux"
import { useDebouncedCallback } from "use-debounce"
export type AddressParams = {
  name?: string | null
  address1?: string | null
  address2?: string | null
  email?: string | null
  zipCodeId?: number | null
}
export interface IAddressProps {
  address: AddressParams
  //address?: CustomerAddress;
  forceRequired: boolean
  setAddress: React.Dispatch<React.SetStateAction<AddressParams>>
  displayLabel: boolean
}
export const Address: FC<IAddressProps> = ({
  address,
  forceRequired,
  setAddress: _setAddress,
  displayLabel = false,
}) => {
  const { t } = useTranslation()
  const [zipCode, setZipCode] = useState<string>("")
  const [lookupZipCode, { data: zipData, called }] = useAppLazyQuery(ZipCodeDocument, {})
  const setAddress = useDebouncedCallback(_setAddress, 150)
  useEffect(() => {
    const [firstZip] = zipData?.zipCodes || []
    if (firstZip) {
      setZipCode && setZipCode(firstZip.zipCode)
      setAddress && setAddress((d) => ({ ...d, zipCodeId: +firstZip.id }))
    }
    // eslint-disable-next-line
  }, [zipData])
  if (!called && address?.zipCodeId) {
    const id = address?.zipCodeId
    if (id) {
      lookupZipCode({ variables: { zipCode: { id } } })
    }
  }
  const onUpdateAddress = ({ target: { name, value } }) => {
    setAddress((d) => ({ ...d, [name]: value }))
  }
  const onChangeZipCode = ({ target: { value: zipCode } }) => {
    setZipCode(zipCode)
    if (zipCode.length >= 4) {
      lookupZipCode({ variables: { zipCode: { zipCode } } })
    } else {
      setAddress((d) => ({ ...d, zipCodeId: null }))
    }
  }
  const zipCodes = zipData?.zipCodes
  const city = (() => {
    if (zipCode.length < 4) {
      return ""
    }
    if (zipCodes && zipCodes.length > 0) {
      return zipCodes[0]?.city
    }
    return ""
  })()
  return (
    <div className={css.addressContainer}>
      <div className={css.addressChild}>
        {displayLabel && (
          <div>
            <PuxLabel>{t("Address.Name")}</PuxLabel>
            <span style={{ color: "var(--pux-color-primary)" }}> *</span>
          </div>
        )}
        <Input
          type="text"
          name="name"
          defaultValue={address?.name || ""}
          onChange={onUpdateAddress}
          required
          forceRequired={forceRequired}
          placeholder={t("Address.Name")}
          title={t("Address.Name")}
          maxLength={50}
        />
      </div>
      {displayLabel && (
        <div className={css.addressLabel}>
          <PuxLabel>{t("Address.Address1")}</PuxLabel>
          <span style={{ color: "var(--pux-color-primary)" }}> *</span>
        </div>
      )}
      <div className={css.addressChild}>
        <Input
          type="text"
          name="address1"
          defaultValue={address?.address1 || ""}
          onChange={onUpdateAddress}
          required
          forceRequired={forceRequired}
          placeholder={t("Address.Address1")}
          title={t("Address.Address1")}
          maxLength={60}
        />
        {displayLabel && (
          <div className={css.addressLabel}>
            <PuxLabel>{t("Address.Address2")}</PuxLabel>
          </div>
        )}
        <Input
          type="text"
          name="address2"
          defaultValue={address?.address2 || ""}
          onChange={onUpdateAddress}
          placeholder={t("Address.Address2")}
          title={t("Address.Address2")}
          maxLength={55}
        />
      </div>
      {displayLabel && (
        <div className={css.addressLabel}>
          <PuxLabel>{t("Address.ZipCity/Place")}</PuxLabel>
          <span style={{ color: "var(--pux-color-primary)" }}> *</span>
        </div>
      )}
      <div className={cx(css.zipContainer)}>
        <div className="flex-none w-[12rem]">
          <Input
            type="text"
            size={4}
            maxLength={4}
            name="zipCode"
            value={zipCode}
            onChange={onChangeZipCode}
            pattern="[0-9]{4}"
            required
            forceRequired={forceRequired}
            placeholder={t("Address.ZipCode")}
            title={t("Address.ZipCode")}
            className={css.zipCode}
          />
        </div>
        <Input
          type="text"
          disabled
          defaultValue={city}
          required
          forceRequired={forceRequired}
          placeholder={t("Address.ZipCity")}
          title={t("Address.ZipCity")}
          className={css.zipCity}
        />
      </div>
    </div>
  )
}
